// src/pages/Login.tsx
import  { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../../../api";
import { useTranslation } from "react-i18next";
import { LoginOutlined, MailOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import {Button,Divider,Input, message, Typography,Spin} from "antd";
// import { useTranslation } from 'react-i18next';
import LanguageToggle from "../../../components/languageToggle";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../../useAuth";

const VerifyupdateInfo = () => {
  const [forgotemail, setForgotEmail] = useState("");
  const [token, setToken] = useState(""); 


  const [searchParams] = useSearchParams();

  const [page, setPage] = useState(1);
  const [error,setError]=useState<String|null> (null)
  const [verified,setVerified]=useState<Boolean> (false)


  const [apiLoading, setApiLoading] = useState(false);
  const navigate = useNavigate(); // Removed if unused
  const {t,i18n}= useTranslation();
  const {logout} = useAuth();
  // const { t } = useTranslation();




  useEffect(() => {
    
  handleReset()
    return () => {
    }
  }, [token])
  
  
  const handleReset = () => {



    setError(null);
      
      
      
    // const formData = new FormData();

  
    
    //   formData.append('token', token);
    //   formData.append('newPassword', password);


   
    
    setApiLoading(true);
    fetch(`${apiUrl}/user-password/verify-update?token=${token}`, {
      method: 'Get',
   
      headers: {
        "Content-Type": "application/json"

     
      },
    }).then((response)=>{
      if(response.status==400){
        setError("Invalid or expiered token")
      }else if(response.status==401){
        setError("Invalid or expiered token")
      }
      else if(response.status==200){
        // message.success("If the email is registered, a reset email is sent.")
        console.log(response)
        //clear session data
        sessionStorage.clear();

         message.success("Email Verified , you can login now.")
         
         setVerified(true)
         logout(false);
     
      }
      return response;
    })

      .then((res) => res)
      .catch((e) => {
console.log(e)
      })
      .finally(() => {
setApiLoading(false)        });
  };



useEffect(() => {
    const tokenFromUrl = searchParams.get("token");

    if (tokenFromUrl) {
        console.log("Token from URL:", tokenFromUrl);
        setToken(tokenFromUrl);
        // You can use the token here, e.g., set it in state or validate it
    }else{
        setError("Invalid password reset link")
    }
}, []);


  return (
    <div dir={i18n.language=="en"?"ltr":"rtl"}  className={`h-screen  flex items-center justify-center px-2 bg-gradient-to-tr from-neo-primary/30   to-neo-primary/0 `}>
   
   
   
    <div className={`bg-white ${page==1?"block":"hidden"}  p-8 shadow-sm rounded-md border-b-4 border-neo-primary/50 w-full md:w-[32rem] lg:w-[32rem] xl:w-[32rem]`}>
      {/* <h1>{t("welcome")}</h1> */}
      <form
      
        >
<div className="flex justify-between items-center" >
<Typography className="text-transparent bg-clip-text bg-gradient-to-r from-neo-primary 
        to-neo-matt font-poppins-700 mb-4 text-3xl">
          NeoPaas
        </Typography>

{/* <LanguageToggle/> */}
</div>
        <Divider/>

        {
          apiLoading?
          <div  className="flex justify-center items-center gap-x-2">
               <Typography className="font-poppins-500 text-xl mb-4" >
   Verifing Email
   </Typography>
            <Spin/>
          </div>
          : <div>
            {
              verified?   <div  className="flex justify-center items-center gap-x-2">
              <Typography className="font-poppins-500 text-xl mb-4" >
  Email Verified, profile has been updated
  </Typography>

  <Button 
  className="flex bg-neo-primary text-white"
  icon={<LoginOutlined/>} onClick={()=>{

navigate("/neopaas/portal/login")


  }} >
    Go to login
  </Button>
         
         </div>:
            <div className="h-10 " >
            {error&&<Typography className="text-red-600 font-poppins-400 text-center" >
               {error}
             </Typography>
     }
            </div>
            }
          </div>
        }
      
   
 
        {/* <button
          disabled={apiLoading}
          type="submit"
          className="bg-primary text-white px-4 py-2 rounded-md"
        >
          Login
        </button> */}

    

        <Divider/>
     <div className="flex gap-x-3 justify-end items-center " >
      

{/* 
     <Typography className="font-poppins-400 text-sm text-gray-400" >
{t("versionCode")} : {__COMMIT_HASH__}
</Typography> */}

{/* 
<Button 
    onClick={()=>{setPage(2)}}
    size="large"
    iconPosition="start"

       icon={<InfoCircleFilled/>}
      
      type="text"  >
         Forgot Password?
       </Button> */}

       

     {/* <Button 
     className="bg-gradient-to-tr from-neo-primary  to-neo-primary/80 text-white"
     size="large"
     iconPosition="end"
     onClick={handleReset}
        icon={<LoginOutlined/>}
       
       loading={apiLoading} >
          Reset password
        </Button>
         */}


    
        
     </div>
        



      </form>
    </div>


    <div className={`bg-white ${page==2?"block":"hidden"}  p-8 shadow-sm rounded-md border-b-4 border-neo-primary/50 w-full md:w-[32rem] lg:w-[32rem] xl:w-[32rem]`}>
      {/* <h1>{t("welcome")}</h1> */}
      <form
       
        >
<div className="flex justify-between items-center" >
<Typography className="text-transparent bg-clip-text bg-gradient-to-r from-neo-primary 
        to-neo-matt font-poppins-700 mb-4 text-3xl">
          NeoPaas
        </Typography>

<LanguageToggle/>
</div>
        <Divider/>
         <Typography className="font-poppins-500 text-xl mb-4" >
       {/* {t("loginToYourAccount")} */}
       Reset Your Password
         </Typography>
        <div className="mb-4">
          <label htmlFor="Email" className="block mb-1 font-poppins-400 text-neo-primary ">
            {t("email")}
          </label>
          <Input
           prefix={<MailOutlined/>}
            type="text"
            id="username"
            className="w-full p-2 border border-gray-300 rounded-md"
            value={forgotemail}
            onChange={(e) => setForgotEmail(e.target.value)}
          />
        </div>
    
   

       <div className="h-10 " >
       {error&&<Typography className="text-red-600 font-poppins-400 text-center" >
          {error}
        </Typography>
}
       </div>

        <Divider/>
     <div className="flex gap-x-3 justify-between items-center " >
      


     <Typography className="font-poppins-400 text-sm text-gray-400" >
{t("versionCode")} : {__COMMIT_HASH__}
</Typography>


<Button 
    
    size="large"
    iconPosition="start"

       icon={<ArrowLeftOutlined/>}
      onClick={()=>{setPage(1)}}
      type="text"  >
         Back
       </Button>
       

     <Button 
     className="bg-gradient-to-tr from-neo-primary  to-neo-primary/80 text-white"
     size="large"
     iconPosition="end"
     onClick={handleReset}
        icon={<LoginOutlined/>}
       
       loading={apiLoading} >
          Reset Password
        </Button>
        


    
        
     </div>
        



      </form>
    </div>

    </div>
  );
};

export default VerifyupdateInfo;
